<template>
  <div class="mt-3">
    <TopSection
      :title="$t('users') | capitalize"
      :count="count"
    >
      <template v-slot:status>
        <Status
          :count="states[statusTypes.ACTIVE] || 0"
          :text="$t('active') | capitalize"
          :icon="['fas', 'check-circle']"
          color="green"
        />
        <Status
          :count="states[statusTypes.PENDING] || 0"
          :text="$t('pending') | capitalize"
          :icon="['fas', 'question-circle']"
          color="orange"
        />
        <Status
          :count="states[statusTypes.BLOCKED] || 0"
          :text="$t('blocked') | capitalize"
          :icon="['fas', 'exclamation-circle']"
          color="red"
        />
      </template>

      <template v-slot:actions>
        <button
          v-if="dataReady && showCreateUserButton()"
          class="button"
          @click="createUser($route.params.member_id)"
        >
          <i class="far fa-plus-circle table-sub-class mr-1" />
          {{ $t('create_user') | capitalize }}
        </button>
      </template>
    </TopSection>

    <v-server-table
      v-if="dataReady"
      ref="users"
      :url="url"
      :columns="columns"
      :options="options"
      @loaded="loaded"
      @pagination="onPagination"
      @sorted="onSorted"
      @filter="onFilter"
    >
      <!-- USER COLUMN -->
      <template v-slot:user="{ row }">
        <span class="table-main-class d-flex">
          <div class="table-logo">
            <img
              width="20"
              src="@/assets/img/mlc.png"
            />
          </div>
          {{ row.name_and_last_name | capitalize }}
        </span>
      </template>

      <!-- STATUS COLUMN -->
      <template v-slot:status="{ row }">
        <Status
          v-if="row.status == statusTypes.ACTIVE"
          :text="$t('active') | capitalize"
          :icon="['fas', 'check-circle']"
          color="green"
        />
        <Status
          v-if="row.status == statusTypes.PENDING"
          :text="$t('pending') | capitalize"
          :icon="['fas', 'question-circle']"
          color="orange"
        />
        <Status
          v-if="row.status == statusTypes.BLOCKED"
          :text="$t('blocked') | capitalize"
          :icon="['fas', 'exclamation-circle']"
          color="red"
        />
      </template>

      <!-- ACTIONS COLUMN -->
      <template v-slot:actions="{ row }">
        <i
          :id="row.id"
          v-b-tooltip.hover
          style="color:#6f6f6f; font-size:16px;"
          class="clickable float-right"
          :class="actionClass()"
          :title="actionTooltip()"
          @click="editUser(row.id, $route.params.member_id)"
        />
      </template>
    </v-server-table>
  </div>
</template>

<script>
import { capitalize, get } from "lodash"
import {
  doRequest,
  responsePaginatedAdapter,
} from "@/assets/libs/utils"
import { mapGetters, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import { listRouteMixin } from "@/utils/mixins"

export default {
  name: "UsersList",
  mixins: [listRouteMixin],
  data () {
    return {
      states: {},
      organizationName: null,
      url: "users",
      count: "-",
      columns: [
        "user",
        "organization",
        "type",
        "status",
        "actions"
      ],
      options: {
        sortable: ["user", "organization", "type", "status"],
        filterable: true,
        headings: {
          user: capitalize(this.$t("name")),
          status: capitalize(this.$t("status")),
          organization: capitalize(this.$t("memberSociety")),
          type: capitalize(this.$t("Role")),
          actions: ""
        },
        requestFunction (params) {
          const member = this.$route.params.member_id
          if (member !== null) params["member_id"] = member
          params["username"] = params["user"]

          const queryParams = { ...params, ...this.$route.query }
          this.page = Number(get(queryParams, "page", 1))

          return doRequest(this.url, queryParams)
        },
        responseAdapter: this.responseAdapter,
      }
    }
  },
  computed: {
    ...mapGetters("soundsys", ["isSuperUser", "isMlc", "statusTypes", "membersList", "organization"]),
    ...mapState("soundsys", ["dataReady"]),
    readonly () {
      return !this.isSuperUser
    }
  },
  mounted: function () {
    const member_id = this.$route.params.member_id
    ApiCalls.getUserStates({ member_id }).then(x => {
      this.states = {
        active: x.data.active || 0,
        pending: x.data.pending || 0,
        blocked: x.data.blocked || 0
      }
    })
  },
  methods: {
    actionTooltip () {
      if (this.readonly) {
        return "details"
      } else {
        return "edit"
      }
    },
    actionClass () {
      return this.readonly ? "fa fa-eye" : "fa fa-pencil"
    },
    getData () {
      this.$refs.users.getData()
    },
    loaded () {
      this.count = this.$refs.users.$refs.table.count || 0
    },
    createUser (member_id) {
      this.$router.push({
        path: `${this.$route.path}/create`,
        params: { member_id }
      })
    },
    editUser (id, member_id) {
      this.$router.push({
        name: "users-detail",
        params: { id, member_id },
      })
    },
    onFilter (search) {
      this.options.previousPage = null
      this.$router.replace({ query: { ...this.$route.query, fuzzy_search: search, page: 1 } })
    },
    showCreateUserButton () {
      if(!this.$route.params.member_id){
        return true
      } else {
        for (let i=0; i<this.membersList.length; i++){
          if(this.membersList[i].id === parseInt(this.$route.params.member_id)){
            if(!this.isMlc || this.membersList[i].org_type === "MLC"){
              return false
            } else {
              return true
            }
          }
        }
      }
    },
    responseAdapter (resp) {
      return responsePaginatedAdapter(resp)
    },
  },
}
</script>

